const PROMO_PRODUCTS = {
  "47943089389850": {
    NEWLOOK6: ["49921562149146"]
  }
};

function getCookie(name) {
  const value = `; ${document.cookie};`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

async function getCart() {
  const response = await fetch("/cart.js");
  if (response.ok) {
    return response.json();
  } else {
    console.error("Failed to fetch cart:", response.statusText);
    return null;
  }
}

async function getPromoProducts(triggerProductVariantId) {
  const currentCart = await getCart();
  const activePromo = getCookie("discount_code");
  const triggerProduct = PROMO_PRODUCTS[triggerProductVariantId];
  const items = [];

  if (!triggerProduct || !activePromo) return [];
  
  const promoProducts = triggerProduct[activePromo.toUpperCase()];

  if (!promoProducts) return [];
  
  promoProducts.forEach(productVariantId => {
    if (currentCart.items.some(item => item.id.toString() === productVariantId)) return;
    
    items.push({ id: productVariantId, quantity: 1 });
  })

  return items;
}
